export enum ExtensionRequestActionType {
    SAVE_EXTENSION_REQUEST = 'SAVE_EXTENSION_REQUEST',
    GET_EXTENSION_REQUEST_BY_ID = 'GET_EXTENSION_REQUEST_BY_ID',
    UPLOAD_EXTENSION_REQUEST_FILE = 'UPLOAD_EXTENSION_REQUEST_FILE',
    RESPOND_TO_EXTENSION_REQUEST = 'RESPOND_TO_EXTENSION_REQUEST',
    CONFIRM_ANSWERED_EXTENSION_REQUEST = 'CONFIRM_ANSWERED_EXTENSION_REQUEST',
}
